enum MeasurementTypes {
  Imperial = 'imperial',
  Metric = 'metric',
}
export default MeasurementTypes;
